import { useSelector } from 'react-redux';

import { getTab } from './selectors';

import {
    getRoleCreationRequest,
    getRoleDeleteRequest,
    getRoleUpdateRequest,
} from '../roles/selectors';

import {
    getUserCreationRequest,
    getUserDeleteRequest,
    getPasswordResetRequest,
} from '../users/selectors';

export const useTab = () => useSelector(getTab);
export const useRoleCreateRequest = () => useSelector(getRoleCreationRequest);
export const useRoleUpdateRequest = () => useSelector(getRoleUpdateRequest);
export const useRoleDeleteRequest = () => useSelector(getRoleDeleteRequest);
export const useUserCreateRequest = () => useSelector(getUserCreationRequest);
export const useUserDeleteRequest = () => useSelector(getUserDeleteRequest);
export const useUserPasswordResetRequest = () =>
    useSelector(getPasswordResetRequest);
